// Copyright (c) Proto Labs, Inc. All Rights Reserved.
import { TokenManagerLogLevel } from './TokenManagerLogLevel';
export class TokenManagerSettings {
    constructor({ acrValues = 'idp:protolabs_okta', authority, clientId, logLevel = TokenManagerLogLevel.Warn, useUnsecureWebSockets = false, maxRefreshTokenExpireMinutes, monitorOnRedirectUri = true, postLogoutRedirectUri, redirectUri, refreshAccessTokenExpireOffset = 120, 
    // The offline_access scope is present so the oidc-client User object gets a valid refresh_token upon login
    scope = 'openid profile email phone address offline_access global-api-access-scope', timeoutMonitorIntervalMilliseconds = 10000, filterProtocolClaims = true, }, logger, urlUtility) {
        this.automaticSilentRenew = false;
        this.monitorSession = true;
        this.responseType = 'code';
        this.loadUserInfo = true;
        this.revokeTokensOnSignout = true;
        this.stopCheckSessionOnError = false;
        this.maxRefreshTokenExpireSeconds = undefined;
        this.maxSigninAttempts = 2;
        this.monitorTimeout = true;
        this.useUnsecureWebSockets = false;
        this.throwIfInvalidString(authority, 'authority');
        this.throwIfInvalidString(clientId, 'clientId');
        this.throwIfInvalidString(postLogoutRedirectUri, 'postLogoutRedirectUri');
        this.throwIfInvalidString(redirectUri, 'redirectUri');
        this.throwIfInvalidString(scope, 'scope');
        this.logger = logger;
        this.urlUtility = urlUtility;
        this.acrValues = acrValues;
        this.authority = authority;
        this.clientId = clientId;
        this.logLevel = logLevel;
        this.useUnsecureWebSockets = useUnsecureWebSockets;
        this.maxRefreshTokenExpireSeconds = maxRefreshTokenExpireMinutes
            ? maxRefreshTokenExpireMinutes * 60
            : undefined;
        this.monitorOnRedirectUri = !!monitorOnRedirectUri;
        this.postLogoutRedirectUri = postLogoutRedirectUri;
        this.redirectUri = redirectUri;
        this.refreshAccessTokenExpireOffset = refreshAccessTokenExpireOffset;
        this.scope = scope;
        this.timeoutMonitorIntervalMilliseconds = timeoutMonitorIntervalMilliseconds;
        this.filterProtocolClaims = filterProtocolClaims;
        if (!this.monitorOnRedirectUri && this.isAuthCallback()) {
            this.monitorSession = false;
            this.monitorTimeout = false;
        }
        if (this.monitorSession && !this.isSessionMonitoringSupported()) {
            this.logger.warn('TokenManagerSettings: disabling unsupported session monitoring.');
            this.monitorSession = false;
        }
        this.errorRedirectUri = `${new URL(this.authority).origin}/signin/error`;
    }
    throwIfInvalidString(value, name) {
        if (!(value === null || value === void 0 ? void 0 : value.trim())) {
            throw Error(`${name} cannot be null or empty and must be a string`);
        }
    }
    isAuthCallback() {
        return window.location.href.toLowerCase().startsWith(this.redirectUri.toLowerCase());
    }
    isSessionMonitoringSupported() {
        const authorityDomain = this.urlUtility.getDomain(this.authority);
        const redirectDomain = this.urlUtility.getDomain(this.redirectUri);
        this.logger.info(`TokenManagerSettings.isSessionMonitoringSupported: authority domain: ${authorityDomain}, redirect domain: ${redirectDomain}`);
        return authorityDomain === redirectDomain;
    }
}
//# sourceMappingURL=TokenManagerSettings.js.map